
ADILF.define('adilf/apps/profile/app',['require','exports','module','streamhub-sdk/jquery','adilf/handler','adilf/context','adilf/util/config-validator','streamhub-sdk/collection','streamhub-author-content','adilf/util/ads','adilf/apps/profile/views/content-list-view','base64','auth','css!streamhub-sdk/content/css/content','less!streamhub-sdk/modal/css/modal','less!adilf/apps/profile/css/styles'],function (require, exports, module) {/* App: Profile */
"use strict";

var jquery = require('streamhub-sdk/jquery');
var Handler = require('adilf/handler');
var Context = require('adilf/context');
var ConfigValidator = require('adilf/util/config-validator');
var Collection = require('streamhub-sdk/collection');
var AuthorArchive = require('streamhub-author-content');
var AdsHelper = require('adilf/util/ads');
var ProfileContentListView = require('adilf/apps/profile/views/content-list-view');
var base64 = require('base64');
var auth = require('auth');

require('css!streamhub-sdk/content/css/content');
require('less!streamhub-sdk/modal/css/modal');
require('less!adilf/apps/profile/css/styles');

var ProfileStream = function(conf) {
    var self = this;
    self.conf = conf || {};

    self.conf.authorId = self.conf.userId + '@' + Context.getNetworkId();
    self.conf._prefix = "adi-profile";
    self.conf.name = "UserProfile";
    self.conf.limit = self.conf.limit || 25;

    self.adsHelper = new AdsHelper({
        name: self.conf.name
    });

    if(!ConfigValidator.call(self, {
        app: 'UserProfile',
        defaultEl: 'advance-stream-user-comments',
        required: ['authorId']
    })) return;

    Handler.apps[self.conf.name] = self;
    if(self.conf.autoStart) { self.init(); }

};

ProfileStream.prototype.init = function() {
    var self = this;
    
    jquery(self.conf.el).show();

    self.authorArchive = new AuthorArchive(self.conf.authorId, 
        { 'limit': self.conf.limit  }
    );
    self.view = new ProfileContentListView({
        showMore: self.conf.limit,
        initial: self.conf.limit,
        el: self.conf.el,
        prefix: self.conf._prefix,
        adsHelper: self.adsHelper,
        animate: false
    });
    self.authorArchive.pipe(self.view.more);

};

module.exports = ProfileStream;
});
